import { ensureAnonId, getAnonId } from '@wix/answers-bi';

export const triggerBindEvent = () => {
	try {
		ensureAnonId();
	} catch (e) {
		// tslint:disable-next-line:no-console
		console.error('error creating wix client id', e);
	}

	const acid = getAnonId();

	const frame = document.createElement('iframe');
	frame.src = `https://apps.wix.com/answers-wix-integration/msh/beacon?acid=${acid}`;
	frame.style.display = 'none';
	frame.id = 'wix-beacon-frame';
	document.body.appendChild(frame);
};
